import { useTheme } from 'react-jss';

import { ITheme } from '../../../styles/theme';

import { ILoader } from './types';

function Loader({ width = 38, height = 38, className, style }: ILoader) {
  const theme = useTheme<ITheme>();

  return (
    <svg
      style={style}
      className={className}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
      stroke={theme.colors.primary}
    >
      <g fillRule="evenodd">
        <g transform="translate(1 1)" strokeWidth="2">
          <circle strokeOpacity=".5" cx="18" cy="18" r="18" fill="transparent" />
          <path d="M36 18c0-9.94-8.06-18-18-18" fill="transparent">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="1s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </g>
    </svg>
  );
}

export default Loader;
